// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","div":"Footer_div__fMD+8","logo":"Footer_logo__Gkrq2","link":"Footer_link__ljLIL"};